import React from "react";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import { Outlet } from "react-router-dom";
import useMenus from "../Global/useMenus";

const Master = () => {
  const { drawerMenu } = useMenus();
  return (
    // <CommonLayout drawerMenu={drawerMenu}>
      <Outlet />
    // </CommonLayout>
  );
};

export default Master;
